class SmoothScroll {
	constructor({ selector = 'a[href*="#"]' } = {}) {
		this.selector = selector;
		this.onClick = this.onClick.bind(this);
	}

	init() {
		document.addEventListener("click", this.onClick);
	}

	onClick(event) {
		const link = event.target.closest(this.selector);
		if (!link) return;

		const url = new URL(link.href, window.location.href);

		if (
			url.origin !== window.location.origin ||
			url.pathname !== window.location.pathname
		) {
			return;
		}

		if (!url.hash || url.hash === "#") {
			return;
		}

		const targetElement = document.querySelector(url.hash);
		if (!targetElement) {
			return;
		}

		event.preventDefault();

		targetElement.scrollIntoView({
			behavior: "smooth",
			block: "start",
		});

		history.pushState(null, "", url.hash);
	}
}

document.addEventListener("DOMContentLoaded", () => {
	new SmoothScroll().init();
});